// Ported from crehana-frontend-apps: apps/crehana-frontend/src/views/CrehanaLegal/constants.tsx (FRONT-216)
export const PAGE_KEY = 'crehana-legal' as const;
